'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouter = require('react-router');

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Grid = require('react-bootstrap/lib/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

var _constants = require('../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var LogoutPage = (_dec = (0, _mobxReact.inject)('SessionStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(LogoutPage, _Component);

  function LogoutPage(props) {
    _classCallCheck(this, LogoutPage);

    var _this = _possibleConstructorReturn(this, (LogoutPage.__proto__ || Object.getPrototypeOf(LogoutPage)).call(this, props));

    _this.state = {};
    _this._redirectTimeout = null;

    Object.assign(_this.state, {
      redirectMs: 5000
    });
    return _this;
  }

  _createClass(LogoutPage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.logout();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._redirectTimeout) {
        clearTimeout(this._redirectTimeout);
      }
    }
  }, {
    key: 'logout',
    value: function logout() {
      var redirectMs = this.state.redirectMs,
          SessionStore = this.props.SessionStore;


      SessionStore.logout();

      this._redirectTimeout = setTimeout(this.redirect, redirectMs);
    }
  }, {
    key: 'redirect',
    value: function redirect() {
      _reactRouter.browserHistory.push(_constants.AppConstants.ROUTING.login);
    }
  }, {
    key: 'render',
    value: function render() {
      var redirectMs = this.state.redirectMs;


      return _react2.default.createElement(
        _Grid2.default,
        { fluid: true, className: 'page-logout' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Logout' }),
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _Col2.default,
            { className: 'wrapper-logout' },
            _react2.default.createElement(
              'h1',
              null,
              'Logout'
            ),
            _react2.default.createElement(
              'p',
              null,
              'You have been logged out.'
            ),
            _react2.default.createElement(
              'p',
              null,
              'You will be redirected in ',
              redirectMs / 1000,
              ' seconds...'
            )
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return LogoutPage;
}(_react.Component), _class2.propTypes = {
  SessionStore: _propTypes2.default.object
}, _temp)) || _class) || _class) || _class);
var _default = LogoutPage;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(LogoutPage, 'LogoutPage', '/app/src/components/pages/LogoutPage.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/pages/LogoutPage.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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